<template>
  <div>
    <div class="error-message">
      <u-error-handling
        v-if="errorObject"
        :error-object="errorObject"
        class="col-12 mt-4"
      />
    </div>
    <u-loader v-if="isLoading" />
    <div
      v-else
      class="pr-4"
    >
      <div
        v-for="(group, index) in groupings"
        :key="index"
        class="groupingWrapper w-100"
      >
        <div
          class="groupingTitle"
          @click="
            expandedId != group.id
              ? (expandedId = group.id)
              : (expandedId = -1);
            errorObject = null;
            RangeErrorObject = null;
            ListerrorObject = null;
          "
        >
          <i
            v-if="expandedId == group.id"
            class="fa fa-chevron-down mr-4 width20"
          />
          <i
            v-else
            class="fas fa-chevron-right mr-4 width20"
            placement="bottom"
          />
          <span>{{ group.name }}</span>
          <button
            v-if="expandedId != group.id && canUserEdit"
            v-b-modal.deleteGrouping
            v-b-tooltip.hide-overflow
            class="btn btn-danger smallActionButton float-right"
            placement="bottom"
            title="Eingebegruppierung löschen"
            type="button"
            @click="groupingToDelete = group.id"
          >
            <i class="fas fa-trash-alt" />
          </button>
        </div>
        <div
          v-if="group.id == expandedId"
          class="groupingContent"
        >
          <form class="my-4 mx-3">
            <div class="row">
              <div class="col-2">
                <label class="font-weight-bold mt-3">Name</label>
              </div>
              <div class="col-9">
                <v-text-field
                  v-model="group.name"
                  label="Titel"
                />
              </div>
              <div class="col-1">
                <button
                  v-if="canUserEdit"
                  v-b-tooltip.hide-overflow
                  class="btn btn-success smallActionButton mt-3 mr-1 ml-4"
                  placement="bottom"
                  title="Name Speichern"
                  type="button"
                  @click="saveGroupingName(group)"
                >
                  <i class="fas fa-check" />
                </button>
                <button
                  v-if="canUserEdit"
                  v-b-tooltip.hover
                  class="btn btn-danger smallActionButton mt-3"
                  placement="bottom"
                  title="Abbrechen"
                  type="button"
                  @click="getGroupings()"
                >
                  <i class="fas fa-times" />
                </button>
              </div>
            </div>

            <div class="row mt-2">
              <div class="col-2">
                <label class="font-weight-bold mt-3">Gruppierungswerte</label>
              </div>
              <div class="col-10">
                <criteria-groups-list
                  v-model="group.groupEntries"
                  :contract-id="contractId"
                  :edition-id="editionId"
                  :group-id="group.id"
                  :version-id="versionId"
                  @requireReload="getGroupings()"
                />
              </div>
            </div>
            <u-error-handling
              v-if="ListerrorObject"
              :error-object="ListerrorObject"
              :property-mapping="listErrorPropertyMappings"
              class="col-12 mt-4"
            />
          </form>
        </div>
      </div>
    </div>
    <div class="col-12 my-4">
      <button
        v-if="
          groupings.filter((item) => {
            return item.id == 0;
          }).length > 0
        "
        v-b-tooltip.hover
        class="btn btn-success float-right actionButton"
        placement="bottom"
        title="Speichern Sie zuerst alle neu erstellten Grupierungen"
        type="button"
      >
        <i class="fas fa-plus" />
      </button>
      <button
        v-else-if="canUserEdit"
        v-b-tooltip.hover
        class="btn btn-success float-right actionButton"
        placement="bottom"
        title="Neue Gruppierung hinzufügen"
        type="button"
        @click="addNewGroupingItem()"
      >
        <i class="fas fa-plus" />
      </button>
    </div>
    <b-modal
      id="deleteGrouping"
      ref="deleteGrouping"
      class="w-100"
      hide-footer
      no-fade
      scrollable
      title="Eingebegruppierung löschen"
    >
      <div class="d-block mb-4">
        Sind Sie sicher, dass Sie diese Eingabegruppierung löschen möchten?
      </div>
      <b-button
        variant="success"
        @click="deleteGrouping()"
      >
        Ok
      </b-button>
      <b-button
        class="ml-2"
        variant="danger"
        @click="
          expandedId = -1;
          hideModal('deleteGrouping');
        "
      >
        Abbrechen
      </b-button>
    </b-modal>
  </div>
</template>

<script>
import CriteriaGroupsList from "@/components/minimum.wage/pages/CriteriaGroups/CriteriaGroupsList.vue";
import {
  CreateGrouping,
  DeleteGrouping,
  UpdateGroupingName,
} from "@/services/minimum.wage.services/groupings.minimum.wages.js";
import { MinimumWageMixin } from "@/components/minimum.wage/mixins/MinimumWageMixin";

const VUEX_IDENTIFIER = "Groupings";

export default {
  components: {
    CriteriaGroupsList,
  },
  mixins: [MinimumWageMixin],
  data() {
    return {
      groupingToDelete: null,
      expandedId: -1,
      operators: [
        { value: 1, name: "Equals", displayName: "=" },
        { value: 2, name: "LessThanOrEqual", displayName: "<=" },
        { value: 3, name: "GreaterThanOrEqual", displayName: ">=" },
      ],
      allTitles: [],
    };
  },
  computed: {
    groupings() {
      return this.$store.state.mindestLohnKonfiguration.Groupings;
    },
    isLoading() {
      return this.$store.getters.isInputGroupingsLoading;
    },
    errorObject() {
      return this.$store.state.errorObjects.Groupings;
    },
  },
  created() {
    this.getGroupings();
  },
  methods: {
    hideModal(modalRef) {
      this.$refs[modalRef].hide();
    },
    saveGroupingName(group) {
      this.startLoading(VUEX_IDENTIFIER);

      UpdateGroupingName(
        this.contractId,
        this.versionId,
        this.editionId,
        group.id,
        group,
        () => {
          this.getGroupings();
          this.stopLoading(VUEX_IDENTIFIER);
        },
        (error) => {
          this.stopLoading(VUEX_IDENTIFIER, error);
        },
      );
    },
    deleteGrouping() {
      this.hideModal("deleteGrouping");
      this.startLoading(VUEX_IDENTIFIER);

      DeleteGrouping(
        this.contractId,
        this.versionId,
        this.editionId,
        this.groupingToDelete,
        () => {
          this.groupingToDelete = null;
          this.getGroupings();
          this.expandedId = -1;
        },
        (error) => {
          this.expandedId = -1;
          this.stopLoading(VUEX_IDENTIFIER, error);
        },
      );
    },
    getGroupings() {
      this.$store.dispatch("getInputGroupings", {
        contractId: this.contractId,
        versionId: this.versionId,
        editionId: this.editionId,
      });
    },
    addNewGroupingItem() {
      this.startLoading(VUEX_IDENTIFIER);

      var newItem = {
        id: 0,
        name: "Neue Gruppe",
        groupEntries: [],
      };

      CreateGrouping(
        this.contractId,
        this.versionId,
        this.editionId,
        newItem,
        () => {
          this.getGroupings();
          this.expandedId = -1;
        },
        (error) => {
          this.expandedId = -1;
          this.stopLoading(VUEX_IDENTIFIER, error);
        },
      );
    },
  },
};
</script>

<style scoped>
.smallActionButton {
  width: 30px;
  height: 30px;
  padding: 1px;
}

.table th {
  border-top: none;
}

.table td {
  padding: 0.1rem;
  padding-left: 0.75rem;
}

.width20 {
  width: 20px;
}

.groupingWrapper {
  border-bottom: 1px solid rgb(200, 200, 200);
}

.groupingTitle {
  font-size: 1.2rem;
  cursor: pointer;
  font-weight: bold;
  border-bottom: 1px solid rgb(235, 235, 235);
  padding: 7px;
}

.accordion-enter-active {
  transition: 1s;
}

.accordion-leave-active {
  transition: 0.2s;
}

.accordion-enter {
  max-height: 0px;
}

.accordion-leave-to {
  max-height: 0px;
}

.error-message {
    white-space: pre-line;
}
</style>
